import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/geographicPickup'

export const geoPickupService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search
};

function search(max, offset, searchFilter) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', searchFilter)
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}